import axios from 'axios';

class SignupError extends Error {
    constructor(message, type = 'GENERAL') {
        super(message);
        this.name = 'SignupError';
        this.type = type;
    }
}

export const signup = async (signupData) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API}/auth/signup`,
            signupData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
            }
        );
        return response.data;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            const { status, data } = error.response;
            
            switch (status) {
                case 400:
                    throw new SignupError(
                        data.message || 'Dados inválidos. Por favor, verifique as informações fornecidas.',
                        'VALIDATION'
                    );
                case 409:
                    throw new SignupError(
                        'Este e-mail já está cadastrado. Por favor, use outro e-mail ou faça login.',
                        'DUPLICATE'
                    );
                case 500:
                    throw new SignupError(
                        'Erro no servidor. Por favor, tente novamente mais tarde.',
                        'SERVER'
                    );
                default:
                    throw new SignupError(
                        'Ocorreu um erro inesperado. Por favor, tente novamente.',
                        'UNKNOWN'
                    );
            }
        } else if (error.request) {
            // The request was made but no response was received
            throw new SignupError(
                'Erro de conexão. Por favor, verifique sua conexão com a internet.',
                'NETWORK'
            );
        } else {
            // Something happened in setting up the request that triggered an Error
            throw new SignupError(
                'Ocorreu um erro inesperado. Por favor, tente novamente.',
                'UNKNOWN'
            );
        }
    }
};
